// React
import { useEffect, useState } from "react"

// Types
import { SuccessFetch } from "types"
import { LinkAccountType } from "../../types"

// Utils
import { useApi } from "utils"

export function useListAccount() {
	// Hooks
	const api = useApi()
	const [data, setData] = useState<LinkAccountType[]>([])
	const [isLoading, setLoading] = useState(false)

	const fetchData = () => {
		setLoading(true)

		api.get(
			"/dashboardlink/"
		).then((res: SuccessFetch<{
			payload: LinkAccountType[]
		}>) => {
			setData(res.data.payload)
		}).catch(() => {
			setData([])
		}).finally(() => {
			setLoading(false)
		})
	}

	useEffect(() => {
		fetchData()

		return () => {
			setData([])
			setLoading(true)
		}

		// eslint-disable-next-line
	}, [])

	return { data, isLoading, refetch: fetchData }
}